import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

interface Props {
  columns: GridColDef[];
  rows: any[];
  loading: boolean;
  entityLabel?: string;
  onAdd: () => void;
  onEdit?: (data: any) => void;
  onDelete?: (data: any) => void;
}
// DynamicDataGridTemplate Component
// A reusable data grid component that can be used to render tables/grids.
// Accepts columns, rows, and other configuration props.

const DynamicDataGridTemplate: React.FC<Props> = ({
  columns,
  rows,
  loading,
  entityLabel,
  onAdd,
  onDelete,
}) => {
  return (
    <Box>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div></div>
        <Button onClick={onAdd} startIcon={<AddIcon />}>
          Add {entityLabel || "Item"}
        </Button>
      </div>
      <DataGrid
        rows={rows}
        getRowId={(row) => {
          return row._id;
        }}
        columns={columns}
        loading={loading}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }}
        pageSizeOptions={[10, 20, 50]}
      />
    </Box>
  );
};

export default DynamicDataGridTemplate;
